import React from "react";
import { Button } from "./style";
import { ReactComponent as ArrowRight } from '../../../assets/svg/right-arrow.svg';

export function ButtonLink(props) {
  return (
    <Button to={props.link} className={props.class} disabled={props.disabled}>{props.label}<ArrowRight/></Button>
  );
}
